import script from "./CapsuleTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CapsuleTemplate.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__